export default __webpack_public_path__ + "static/media/copy.a538c7ec.svg";